
/**
 * 상세 에러 정보 (선택적)
 * @nullable
 */
export type ChatStream400Details = { [key: string]: unknown } | null;
